import { Component, Input } from '@angular/core';
import { DailyLegLoadFrequencyEditor } from '../../../../../models/daily-leg-loads/daily-leg-load.models';
import { DateService } from '../../../../../services/date/date.service';
import { PtLuxonDate } from '../../../../../models/projects/date.models';
import { AppConfig } from '../../../../../app/app.config';
import { NavParams, ViewController } from 'ionic-angular';
import { DailyLegLoadFrequencyService } from '../../../../../services/daily-leg-loads/daily-leg-load-frequency.service';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'daily-leg-loads-add-frequency',
  templateUrl: 'daily-leg-loads-add-frequency.html'
})
export class DailyLegLoadsAddFrequencyComponent {
  config = AppConfig.settings;
  dailyLogDate: PtLuxonDate;
  isWeb: boolean;
  currentEditor: DailyLegLoadFrequencyEditor;

  mask: Array<string | RegExp> = [/[0-2]/, /\d/, ':', /[0-5]/, /\d/];
  newFrequencyShow: string;
  saveLoading: boolean;
  effectiveFromValid: boolean;

  constructor(private dateService: DateService,
              public navParams: NavParams,
              public viewController: ViewController,
              private dailyLegLoadFrequencyService: DailyLegLoadFrequencyService,
  ) {
    this.dailyLogDate = this.navParams.get('dailyLogDate');
    this.isWeb = this.navParams.get('isWeb');
    this.currentEditor = new DailyLegLoadFrequencyEditor();
    this.saveLoading = false;
  }

  regexChange(inputTime: string, allow24Hour?: boolean) {
    if (inputTime.charAt(0) === '2') {
      if (!allow24Hour) {
        this.mask[1] = new RegExp('[0-3]');
      } else {
        this.mask[1] = new RegExp('[0-4]');
      }
    } else {
      this.mask[1] = new RegExp('\\d');
    }

    // max frequency is 24 hours, so this stops them going above it
    if (inputTime.charAt(1) === '4') {
      this.mask[3] = new RegExp('0');
      this.mask[4] = new RegExp('0');
    } else {
      this.mask[3] = new RegExp('[0-5]');
      this.mask[4] = new RegExp('[0-9]');
    }
  }

  checkNewFrequencyValid(): boolean {
    return this.dateService.timeIsValid(this.newFrequencyShow, null, true) && this.newFrequencyShow !== '';
  }

  async closeModal(choice: boolean) {
    if (choice) {
      await this.saveFrequencyEditor();
    }

    this.viewController.dismiss({choice: choice});
  }

  async saveFrequencyEditor() {
    this.saveLoading = true;
    const newEditor = new DailyLegLoadFrequencyEditor();
    newEditor.frequencyShow = this.newFrequencyShow;
    newEditor.frequencySeconds = this.dateService.setSecondsFromTimeShow(this.newFrequencyShow);
    newEditor.observationStartTimeShow = this.currentEditor.observationStartTimeShow;
    newEditor.observationEndTimeShow = this.currentEditor.observationEndTimeShow;
    newEditor.effectiveFromDateOffset = this.currentEditor.effectiveFromDate.dateTime.offset / 60;
    newEditor.effectiveFromDate = cloneDeep(this.currentEditor.effectiveFromDate);

    await this.dailyLegLoadFrequencyService.saveDailyLegLoadFrequencyEditor(newEditor);
  }

  offsetSelected(offsetSelectedPtDate: PtLuxonDate) {
    this.currentEditor.effectiveFromDateOffset = offsetSelectedPtDate.dateTime.offset / 60;
  }

  async effectiveFromAltered() {
    this.effectiveFromValid = this.dateService.timeIsValid(this.currentEditor.effectiveFromDateShow);

    if (!this.effectiveFromValid || this.currentEditor.effectiveFromDateShow === '') {
      return;
    }

    this.currentEditor.effectiveFromDate = await this.dateService
      .setPtLuxonDateFromUserEnteredString(this.currentEditor.effectiveFromDateShow, this.dailyLogDate.dateTime, this.currentEditor.effectiveFromDateOffset);
  }
}



// WEBPACK FOOTER //
// ./src/pages/daily-leg-loads/daily-leg-load-manage-readings/components/daily-leg-load-add-frequency/daily-leg-loads-add-frequency.ts